import { Box, Typography } from '@mui/material';

import { convertToCurrency } from '../../../utils';

type McPromoCheckoutDisplayProps = {
  originalPrice: number;
  promoPrice: number;
  quantity: number;
  hasGst: boolean;
};

/**
 * Displays promotional pricing for MC items with strikethrough on original price.
 * Shows promo badge and special pricing indicator.
 */
export const McPromoCheckoutDisplay = ({
  originalPrice,
  promoPrice,
  quantity,
  hasGst,
}: McPromoCheckoutDisplayProps) => {
  const displayOriginalPrice = hasGst ? originalPrice / 1.1 : originalPrice;
  const displayPromoPrice = hasGst ? promoPrice / 1.1 : promoPrice;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 0.5 }}>
      <Typography variant="caption" sx={{ textDecoration: 'line-through', color: 'text.secondary' }}>
        {convertToCurrency(displayOriginalPrice * quantity)}
      </Typography>
      <Typography fontWeight="bold" sx={{ color: '#2AAFBB' }}>
        {convertToCurrency(displayPromoPrice * quantity)}
      </Typography>
    </Box>
  );
};
